import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { resetRedirectPatientForm } from "~/store/patientForm/patientFormAction";
import { get, find } from "lodash";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PatientRecordsDetailPageMobile = Loadable({
  loader: () =>
    import(/* mobile */ "~/components/desktop/pages/PatientRecordsDetail"),
  loading: LoadableLoading
});
const PatientRecordsDetailPageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/PatientRecordsDetail"),
  loading: LoadableLoading
});

class DetectPatientRecordsDetail extends Component {
  componentWillUnmount() {
    this.props.resetRedirectPatientForm();
  }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PatientRecordsDetailPageMobile />
        ) : (
          <PatientRecordsDetailPageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const mapDispatchToProps = dispatch => ({
  resetRedirectPatientForm: () => {
    dispatch(resetRedirectPatientForm());
  }
});

const PatientRecordsDetailHelmet = withTitle({
  component: DetectPatientRecordsDetail,
  title: `${hospitalName.value} | Chi tiết hồ sơ bệnh nhân`
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientRecordsDetailHelmet);
